import { Button, InputText } from '@/components';
import React, { JSX } from 'react';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputCheck } from '../types';

interface Props {
  state: boolean;
  formData: FormData;
  formErrors: FormErrors;
  onChangeFormInput: OnChangeFormInput;
  onSendConfirmEmail: () => void;
}

export const CheckAccountContent: React.FC<Props> = ({
  state,
  formData,
  formErrors,
  onChangeFormInput,
  onSendConfirmEmail,
}): JSX.Element => (
  <div>
    <div className="mt-8 w-full">
      <form onSubmit={e => e.preventDefault()}>
        <div className="mb-[20px]">
          <InputText
            name="cpf"
            label="CPF"
            placeholder="123.456.789-00"
            className={`appearance-none w-full
                            rounded-md text-heading leading-tight focus:outline-none
                            focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputCheck.cpf]}
            onChange={e => onChangeFormInput(FormInputCheck.cpf)(e.target.value)}
            error={formErrors.cpf && formErrors.cpf[0]}
          />
        </div>
        <div
          className="mb-[20px] flex flex-col items-start justify-between"
          id="termsAndConditions"
        >
          <Button
            type="button"
            title="Confirmar"
            buttonStyle="primary"
            size="xlg"
            className="w-full"
            onClick={onSendConfirmEmail}
            disabled={formData[FormInputCheck.cpf] === '' || state}
          />
        </div>
      </form>
    </div>
  </div>
);
